import React, { useRef, useState } from "react";
import "./Options.css";
import {
  undo,
  redo,
  info,
} from "../../../assets/icons";
import {
  FiEdit3,
  FiGrid,
  FiMonitor,
  FiRefreshCw,
  FiType,
} from "react-icons/fi";
import { RoleName, NameOnly, Songs, Logos, Blurb } from "./OptionBlocks";
import { useSelector, useDispatch } from "react-redux";
import {
  redoOptions,
  redoCardScreen,
  redoTypography,
  applyLayoutPreset,
  saveProjectGlobalOption,
  undoOptions,
  undoCardScreen,
  undoTypography,
  updateProjectCredits,
  updateProjectCreditsByGoogle,
} from "../../../Redux/actions/projectActions";
import OptionFont from "./OptionFont/OptionFont";
import { selectedOption } from "../../../Redux/actions/projectActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ScreenOption from "../Cards/components/ScreenOption";
// import Button from "../../../Components/Button/Button_2";
import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { Button } from "../../../Components";
import { AiOutlineGlobal } from "react-icons/ai";
import RenderNew from "../Render/RenderNew";
import CardRender from "../Cards/CardRender";
import { selectedPageOption } from "../../../Redux/actions/commonActtion";
import ScrollRender from "../Render/June2026/scroll/ScrollRender";
import CardRender2 from "../Render/June2026/card/CardRender";
import { flushPendingProjectSaves } from "../projectSaveCoordinator";
import { LayoutDisclosureProvider } from "./OptionBlocks/LayoutDisclosureContext";
import QuickLayoutPresets from "./OptionBlocks/QuickLayoutPresets/QuickLayoutPresets";
import { formatCreditsSyncTime } from "./creditsSyncTime";
import ScrollEndBehavior from "./OptionBlocks/ScrollEndBehavior/ScrollEndBehavior";
import OverflowScrollCue from "../../../Components/OverflowScrollCue/OverflowScrollCue";
import LayoutHelpTooltipLayer from "./OptionBlocks/LayoutHelpTooltipLayer";

const getBlockName = (blockType) => {
  switch (blockType?.toLowerCase()) {
    case "rolename":
      return "Role + Name";
    case "nameonly":
      return "Name Only";
    case "logo":
      return "Logos";
    case "blurb":
      return "Blurb";
    case "song":
      return "Songs";
    default:
      return "Name Only";
  }
};

const getOptionBlock = (
  options,
  currentBlockIdx,
  currentBlockId,
  setReLoading,
  isCard,
) => {
  switch (options.block_type?.toLowerCase()) {
    case "rolename":
      return (
        <RoleName
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "nameonly":
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "logo":
      return (
        <Logos
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          setReLoading={setReLoading}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "blurb":
      return (
        <Blurb
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "song":
      return (
        <Songs
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    default:
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
  }
};

const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name,
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    return { error, data: null };
  }
};

const Options = ({
  currentBlockOptions,
  currentBlockIdx,
  currentBlockId,
  setReLoading,
  isOptionSelected,
  isCard,
  setIsRenderExport,
  isRenderExport,
  aspectRatio_FrameSize,
  setAspectRatio_FrameSize,
}) => {
  const [selected, setSelected] = useState("options");
  const settingsScrollRef = useRef(null);
  const [isPreparingRender, setIsPreparingRender] = useState(false);
  const [blockName, setBlockName] = useState(currentBlockOptions.block_type);
  const objectMap = useSelector((state) => state.undoRedo);
  const typographyUndoStack = useSelector(
    (state) => state.fontUndoRedo?.obj,
  );
  const screenHistory = useSelector((state) => state.screenUndoRedo);
  const currentLayoutHistory = Array.isArray(objectMap)
    ? objectMap.find((entry) => entry.creditsId === currentBlockId) ||
      objectMap[currentBlockIdx]
    : null;
  const undoStack = currentLayoutHistory?.obj;
  const layoutFontUndoStack = currentLayoutHistory?.layoutFontObj;
  const screenUndoStack = Array.isArray(screenHistory)
    ? (screenHistory.find((entry) => entry.creditsId === currentBlockId) ||
        screenHistory[currentBlockIdx])?.obj
    : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const id = "66e14a11eedf1bfc39f94b39";
  const location = useLocation();
  const { isDashboard = false } = location?.state || {};
  const isRenderPage = location.pathname.endsWith("/render");
  const editorPath = isCard
    ? `/dashboard/card/${projectId}`
    : `/dashboard/scroll/${projectId}`;
  const renderPath = `${editorPath}/render`;

  const setRenderOpen = (open) => {
    navigate(open ? renderPath : editorPath, {
      state: {
        isDashboard: isDashboard,
        isRender: Boolean(open),
        projectId: projectId,
        isCard: Boolean(isCard),
      },
    });
  };

  const OptionHandler = (val) => {
    dispatch(selectedOption(val));
  };

  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
    fontStyle: currentFontStyle,
    lastCreditsSyncedAt,
  } = useSelector((state) => state?.project);

  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(
          _id,
          googleSpreadSheetId,
          currentCredits,
          isCard,
        ),
      );
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle,
          );
        }, 300);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              isError
              title={res?.response?.data?.title || "Error"}
              content={res?.response?.data?.message}
            />,
            customToatStyleError,
          );
        }, 2000);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
    }
  };

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits,
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };

  // Function to apply settings to all scroll
  const applyToAll = () => {
    dispatch(
      saveProjectGlobalOption(
        currentBlockId,
        currentBlockOptions,
        currentBlockOptions.block_type,
        isCard,
      ),
    );
    toast(
      <CustomToast
        title=""
        content={`Changes applied to all ${currentBlockOptions.block_type} blocks.`}
      />,
      customToatStyle,
    );
  };

  const OptionHandlerRender = async () => {
    if (isPreparingRender) return;
    setIsPreparingRender(true);
    try {
      await flushPendingProjectSaves();
      dispatch(selectedPageOption("renderPage", _id, isCard));
      setRenderOpen(true);
    } catch (error) {
      toast(
        <CustomToast
          isError
          title="Save failed"
          content="Your latest changes could not be saved. Please try Render again."
        />,
        customToatStyleError,
      );
    } finally {
      setIsPreparingRender(false);
    }
  };

  return (
    <div className="OptionContainer">
      <div className="optionHdr">
        <div className="Layout">
          <div className="Layout-title">
            <div className={isCard ? `Layout-titleBlkCrd` : `Layout-titleBlk`}>
              <div
                className={
                  "layout-text " + (selected === "options" ? "selected" : "")
                }
                onClick={() => {
                  setSelected("options");
                  OptionHandler("layout");
                }}
              >
                <FiGrid className="layout-text__icon" aria-hidden="true" />
                <span>Layout</span>
              </div>

              <div
                className={
                  "layout-text " + (selected === "fonts" ? "selected" : "")
                }
                onClick={() => {
                  setSelected("fonts");
                  OptionHandler("font");
                }}
              >
                <FiType className="layout-text__icon" aria-hidden="true" />
                <span>Typography</span>
              </div>

              {isCard && (
                <div
                  className={
                    "layout-text " + (selected === "screen" ? "selected" : "")
                  }
                  onClick={() => {
                    setSelected("screen");
                    OptionHandler("screen");
                  }}
                >
                  <FiMonitor
                    className="layout-text__icon"
                    aria-hidden="true"
                  />
                  <span>Screen</span>
                </div>
              )}

              {selected === "options" &&
                currentBlockOptions.block_type?.toLowerCase() !== "logo" && (
                  <div className="undo-redo" aria-label="Layout history">
                    <button
                      type="button"
                      aria-label="Undo layout change"
                      disabled={
                        !undoStack?.canUndo && !layoutFontUndoStack?.canUndo
                      }
                      onClick={() =>
                        dispatch(undoOptions(currentBlockId, isCard))
                      }
                    >
                      <img src={undo} alt="" aria-hidden="true" />
                      <span role="tooltip">Undo</span>
                    </button>
                    <button
                      type="button"
                      aria-label="Redo layout change"
                      disabled={
                        !undoStack?.canRedo && !layoutFontUndoStack?.canRedo
                      }
                      onClick={() =>
                        dispatch(redoOptions(currentBlockId, isCard))
                      }
                    >
                      <img src={redo} alt="" aria-hidden="true" />
                      <span role="tooltip">Redo</span>
                    </button>
                  </div>
                )}

              {selected === "fonts" &&
                currentBlockOptions.block_type?.toLowerCase() !== "logo" && (
                  <div className="undo-redo" aria-label="Typography history">
                    <button
                      type="button"
                      aria-label="Undo typography change"
                      disabled={!typographyUndoStack?.canUndo}
                      onClick={() => dispatch(undoTypography(isCard))}
                    >
                      <img src={undo} alt="" aria-hidden="true" />
                      <span role="tooltip">Undo</span>
                    </button>
                    <button
                      type="button"
                      aria-label="Redo typography change"
                      disabled={!typographyUndoStack?.canRedo}
                      onClick={() => dispatch(redoTypography(isCard))}
                    >
                      <img src={redo} alt="" aria-hidden="true" />
                      <span role="tooltip">Redo</span>
                    </button>
                  </div>
                )}

              {isCard && selected === "screen" && (
                <div className="undo-redo" aria-label="Screen history">
                  <button
                    type="button"
                    aria-label="Undo screen change"
                    disabled={!screenUndoStack?.canUndo}
                    onClick={() => dispatch(undoCardScreen(currentBlockId))}
                  >
                    <img src={undo} alt="" aria-hidden="true" />
                    <span role="tooltip">Undo</span>
                  </button>
                  <button
                    type="button"
                    aria-label="Redo screen change"
                    disabled={!screenUndoStack?.canRedo}
                    onClick={() => dispatch(redoCardScreen(currentBlockId))}
                  >
                    <img src={redo} alt="" aria-hidden="true" />
                    <span role="tooltip">Redo</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="Layout-screen">
            {selected === "options" ? (
              <div className="Mainlayout-screen" ref={settingsScrollRef}>
                <div className="Block-type border-[#ffffff0e] border-b-[1px]">
                  {selected !== "screen" && (
                    <div className="selected-block-type-help Block-text cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4 text-white">
                      <span className="cursor-help">Selected Block Type</span>
                      <span
                        role="tooltip"
                        className="selected-block-type-tooltip"
                      >
                        The format structure for this credit block (e.g., Role +
                        Name).
                      </span>
                    </div>
                  )}
                  <div
                    className={
                      selected === "screen" ? "crdBlock-name" : "Block-name"
                    }
                  >
                    {selected !== "screen" && (
                      <div
                        className={{
                          marginLeft: selected === "fonts" ? "10px" : "",
                        }}
                      >
                        <span>
                          {getBlockName(currentBlockOptions.block_type)}
                        </span>
                      </div>
                    )}
                    {selected === "screen" && (
                      <div className="">
                        <p>Card {currentBlockIdx + 1}</p>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <LayoutDisclosureProvider>
                    <QuickLayoutPresets
                      options={currentBlockOptions}
                      fontStyle={currentFontStyle}
                      onApply={(presetOptions, typographyOverrides) =>
                        dispatch(
                          applyLayoutPreset(
                            currentBlockId,
                            isCard,
                            presetOptions,
                            typographyOverrides,
                          ),
                        )
                      }
                    />
                    {getOptionBlock(
                      currentBlockOptions,
                      currentBlockIdx,
                      currentBlockId,
                      setReLoading,
                      isCard,
                    )}
                    {!isCard &&
                      currentBlockIdx === currentCredits?.length - 1 && (
                        <ScrollEndBehavior />
                      )}
                  </LayoutDisclosureProvider>
                </div>

                <div className="mt-[6px] py-[11px] px-[14px] rounded-xl flex justify-between items-center  border-[1px] border-[#7c5cff2e] bg-[#7c5cff14]">
                  <div className="sx-global-settings__label font-body text-[13px] text-[#f0eeff] font-medium">
                    <AiOutlineGlobal aria-hidden="true" />
                    <span>Global Settings</span>
                  </div>
                  <div className="">
                    <button onClick={applyToAll} className="global-btn ">
                      <AiOutlineGlobal className="text-[1rem]" />
                      Apply to all
                    </button>
                  </div>
                </div>
              </div>
            ) : selected === "screen" ? (
              <div className="Mainlayout-screen" ref={settingsScrollRef}>
                <ScreenOption
                  currentBlockOptions={currentBlockOptions}
                  currentBlockIdx={currentBlockIdx}
                  currentBlockId={currentBlockId}
                  isCard={isCard}
                />
              </div>
            ) : (
              <div className="Mainlayout-screen" ref={settingsScrollRef}>
                <OptionFont isCard={isCard} />
              </div>
            )}
            <OverflowScrollCue targetRef={settingsScrollRef} watchKey={selected} />
            <LayoutHelpTooltipLayer
              targetRef={settingsScrollRef}
              watchKey={selected}
            />
          </div>
        </div>
      </div>

      <div className="optionFtr credit-sheet-footer border-t-[1px] border-[#ffffff0e]">
        <div className="credit-sync-status" aria-live="polite">
          {formatCreditsSyncTime(lastCreditsSyncedAt)}
        </div>
        <div className="credit-sheet-actions">
          <div
            className="Credit-btn w-1/2"
            onClick={() => window.open(googleSheetLink)}
          >
            <FiEdit3 className="w-[15px] h-[15px]" aria-hidden="true" />
            <span className=" text-[13px] text-white font-[650]">
              Credit Sheet
            </span>
          </div>

          {googleSheetLink ? (
            <div
              className="Credit-btn w-1/2 font-medium"
              onClick={handleGoogleUpdate}
            >
              <FiRefreshCw
                className="w-[15px] h-[15px]"
                aria-hidden="true"
              />
              <span className="text-[13px] text-white font-[650]">
                Sync Credits
              </span>
            </div>
          ) : (
            <div className="Credit-btn w-1/2" aria-disabled="true">
              <FiRefreshCw
                className="w-[15px] h-[15px]"
                aria-hidden="true"
              />
              <span className="text-[13px] text-white font-[650]">
                Sync Credits
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        className={`optionFtr ${isPreparingRender ? "pointer-events-none opacity-70" : ""}`}
        onClick={OptionHandlerRender}
        aria-disabled={isPreparingRender}
      >
        <div className="OptionRender-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.2}
            strokeLinecap="round"
            strokeLinejoin="round"
            width={24}
            height={24}
          >
            <polygon points="23 7 16 12 23 17 23 7" />
            <rect x="1" y="5" width="15" height="14" rx="2" />
          </svg>
          <span className="">
            {isPreparingRender ? "Saving changes..." : "Render"}
          </span>
        </div>

        {/* {renderOpen && !isCard && (
        <RenderNew
          renderOpen={renderOpen}
          setRenderOpen={setRenderOpen}
          currentBlockIdx={currentBlock?.idx}
          isRenderExport={isRenderExport}
          setIsRenderExport={setIsRenderExport}
        />
      )} */}

        {isRenderPage && !isCard && (
          <ScrollRender
            renderOpen={isRenderPage}
            setRenderOpen={setRenderOpen}
            currentBlockIdx={currentBlock?.idx}
            isRenderExport={isRenderExport}
            setIsRenderExport={setIsRenderExport}
            aspectRatio_FrameSize={aspectRatio_FrameSize}
            setAspectRatio_FrameSize={setAspectRatio_FrameSize}
          />
        )}

        {/* {renderOpen && isCard && (
        <CardRender
          renderOpen={renderOpen}
          setRenderOpen={setRenderOpen}
          currentBlockIdx={currentBlock?.idx}
          isRenderExport={isRenderExport}
          setIsRenderExport={setIsRenderExport}
          isCard={isCard}
        />
      )} */}

        {isRenderPage && isCard && (
          <CardRender2
            renderOpen={isRenderPage}
            setRenderOpen={setRenderOpen}
            currentBlockIdx={currentBlock?.idx}
            isRenderExport={isRenderExport}
            setIsRenderExport={setIsRenderExport}
            isCard={isCard}
          />
        )}
      </div>
    </div>
  );
};

export default Options;
